export default class FormSaveData {
    public formFieldValues: { [key: string]: string } = {};
}